import { LEGAL_LINKS } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import type { UseFormReturn } from "react-hook-form";
import type { RegisterValues } from "./register-page";

const LINK = "font-semibold text-primary-ink hover:underline";

/** Terms + RA 10173 consent (required) and marketing (optional), as on register.html. */
export function RegisterConsents({ form }: { form: UseFormReturn<RegisterValues> }) {
  const { t } = useTranslation();
  const { register, formState } = form;
  const termsError = formState.errors.terms?.message;
  const dpaError = formState.errors.dpa?.message;
  return (
    <div className="space-y-2.5 rounded-lg border border-line bg-surface p-4">
      <label className="flex items-start gap-2.5 text-[13px] text-fg-muted">
        <input type="checkbox" className="checkbox mt-0.5" aria-invalid={termsError ? true : undefined} aria-describedby={termsError ? "consent-terms-error" : undefined} {...register("terms")} />
        <span>
          {t("auth.register.consentTermsLead")}{" "}
          <a href={LEGAL_LINKS.terms} target="_blank" rel="noreferrer" className={LINK}>
            {t("auth.common.termsOfService")}
          </a>{" "}
          {t("auth.register.consentTermsAnd")}{" "}
          <a href={LEGAL_LINKS.privacy} target="_blank" rel="noreferrer" className={LINK}>
            {t("auth.common.privacyNotice")}
          </a>
          .
        </span>
      </label>
      {termsError ? (
        <p id="consent-terms-error" role="alert" className="pl-6 text-xs font-semibold text-danger">
          {termsError}
        </p>
      ) : null}
      <label className="flex items-start gap-2.5 text-[13px] text-fg-muted">
        <input type="checkbox" className="checkbox mt-0.5" aria-invalid={dpaError ? true : undefined} aria-describedby={dpaError ? "consent-dpa-error" : undefined} {...register("dpa")} />
        <span>
          {t("auth.register.consentDpaLead")} <strong className="text-fg">{t("auth.register.consentDpaAct")}</strong> {t("auth.register.consentDpaTail")}
        </span>
      </label>
      {dpaError ? (
        <p id="consent-dpa-error" role="alert" className="pl-6 text-xs font-semibold text-danger">
          {dpaError}
        </p>
      ) : null}
      <label className="flex items-start gap-2.5 text-[13px] text-fg-muted">
        <input type="checkbox" className="checkbox mt-0.5" {...register("marketing")} />
        <span>{t("auth.register.consentMarketing")}</span>
      </label>
    </div>
  );
}
